module.exports = __webpack_public_path__ + "static/media/DZW_04.8b7bae1a.jpg";